import './pages.css';

const Contacts = () => {
    return (
        <div className="page contacts">
            <div className="content-container">
                <h1>Contact Us</h1>
                <p className="page-subtitle">Get in touch with our team</p>

                <div className="contact-grid">
                    <div className="contact-card">
                        <h3>📍 Address</h3>
                        <p>2680 Tremont St, Philadelphia, PA 19152</p>
                    </div>

                    <div className="contact-card">
                        <h3>📞 Phone</h3>
                        <p>+17322309942</p>
                    </div>

                    <div className="contact-card">
                        <h3>📧 Email</h3>
                        <p>info@dentallab.com</p>
                    </div>

                    <div className="contact-card">
                        <h3>🕐 Working Hours</h3>
                        <p>Mon - Sat: 9:00 AM - 6:00 PM</p>
                    </div>
                </div>

                <div className="contact-form">
                    <h2>Send Us a Message</h2>
                    <form>
                        <input type="text" placeholder="Your Name" />
                        <input type="email" placeholder="Your Email" />
                        <input type="tel" placeholder="Phone Number" />
                        <textarea placeholder="Your Message" rows="5"></textarea>
                        <button type="submit" className="btn-primary">Send Message</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Contacts;